export const defaultThemesStyles = {
  colorDanger: '#eb4242',
  colorWarning: '#e49e4c',
  colorWarning15: 'rgba(228, 158, 76, .15)',
  colorMessageBackground: 'rgba(235, 66, 66, .2)',
  colorSuccess: '#59ce88',
  blue80: '#2678d9',
  colorWhite: '#ffffff',
  colorGray50: '#e1edfc',
  fontInterRegular: 'Inter Regular, sans-serif',
  fontInterSemiBold: 'Inter SemiBold, sans-serif',
  fontInterBold: 'Inter Bold, sans-serif',
  fontSizeSmall: '11px',
  fontSizeMedium: '13px',
  fontSizeLarge: '15px',
  transitions: {
    fast: 'all .3s',
    medium: 'all .5s',
    slow: 'all .8s',
  },
};

export const themeLight = {
  black80: '#5a5859',
  black50: '#727272',
  black10: '#e5e5e5',
  black5: '#f2f2f2',
  colorBackgroundPrimary: '#ffffff',
  colorBackgroundSecondary: '#f2f2f2',
  colorLogo: '#090e35',
  colorDark: '#1d234e',
  leftPanelBorder: '#223f61',
  leftPanelText: '#ffffff',
  ...defaultThemesStyles,
};

export const themeDark = {
  black80: '#cacaca',
  black50: '#6c6c6c',
  black10: '#444447',
  black5: '#222224',
  colorBackgroundPrimary: '#373737',
  colorBackgroundSecondary: '#282828',
  colorLogo: '#ffffff',
  colorDark: '#373737',
  leftPanelBorder: '#606060',
  leftPanelText: '#cacaca',
  ...defaultThemesStyles,
};

const defaultTokens = {
  colorPrimary: '#e49e4c',
  fontSize: 13,
  fontSizeLG: 13,
  fontFamily: 'Inter SemiBold, sans-serif',
  colorWarning: '#e49e4c',
  colorDanger: '#eb4242',
  colorPrimaryHover: '#e49e4c',
  colorIconHover: '#e49e4c',
  colorErrorBorderHover: '#eb4242',
  colorErrorHover: '#eb4242',
};

export const antdLightTheme = {
  token: {
    ...defaultTokens,
    colorTextBase: '#5a5859',
    colorBgLayout: '#ffffff',
    colorBgElevated: '#ffffff',
    controlItemBgHover: '#fffaf0',
    colorBgSpotlight: '#ffffff',
    colorTextLightSolid: '#5a5859',
    colorSplit: '#e5e5e5',
    colorBorder: '#e5e5e5',
    colorBorderSecondary: '#e5e5e5',
    colorTextTertiary: '#727272',
  },
  components: {
    Tabs: {
      lineWidthBold: 4,
      colorPrimaryActive: '#5a5859',
    },
    Button: {
      colorTextLightSolid: '#ffffff',
      colorBorder: '#5a5859',
      colorLinkHover: '#e49e4c',
      colorBgContainer: '#ffffff',
      colorLinkActive: '#e49e4c',
    },
    Select: {
      colorBgContainer: '#ffffff',
      colorTextTertiary: '#e49e4c',
      controlItemBgActive: '#fffaf0',
      colorFillSecondary: '#f2f2f2',
    },
    Cascader: {
      colorBgContainer: '#ffffff',
      colorTextTertiary: '#e49e4c',
      controlItemBgActive: '#fffaf0',
      colorFillSecondary: '#f2f2f2',
    },
    Input: {
      colorBgContainer: '#ffffff',
      colorTextTertiary: '#e49e4c',
    },
    InputNumber: {
      colorBgContainer: '#ffffff',
      colorTextTertiary: '#e49e4c',
    },
    DatePicker: {
      colorBgContainer: '#ffffff',
      colorLinkHover: '#e49e4c',
    },
    Tooltip: {
      fontSize: 11,
      colorBgDefault: '#090e35',
      controlHeight: 'auto',
      colorTextLightSolid: '#ffffff',
    },
    Popover: {
      colorBgElevated: '#ffffff',
    },
    Modal: {
      colorBgElevated: '#ffffff',
    },
    Table: {
      colorBgContainer: '#ffffff',
      padding: 10,
      paddingContentVerticalLG: 10,
      colorFillAlter: '#fffaf0',
      controlItemBgActive: '#ffffff',
      controlItemBgActiveHover: '#ffffff',
    },
    Pagination: {
      colorBgContainer: '#ffffff',
      colorBgTextHover: '#fffaf0',
    },
    Radio: {
      wireframe: 'true',
      colorBgContainer: '#ffffff',
    },
  },
};

export const antdDarkTheme = {
  token: {
    ...defaultTokens,
    colorTextBase: '#cacaca',
    colorBgLayout: '#373737',
    colorBgElevated: '#282828',
    controlItemBgHover: 'rgba(228, 158, 76, 0.1)',
    colorBgSpotlight: '#282828',
    colorTextLightSolid: '#cacaca',
    colorSplit: '#444447',
    colorBorder: '#444447',
    colorBorderSecondary: '#444447',
    colorTextTertiary: '#b6b6b6',
  },
  components: {
    Tabs: {
      lineWidthBold: 4,
      colorPrimaryActive: '#cacaca',
    },
    Button: {
      colorTextLightSolid: '#282828',
      colorBorder: '#cacaca',
      colorLinkHover: '#e49e4c',
      colorLinkActive: '#e49e4c',
      colorBgContainer: '#373737',
    },
    Select: {
      colorBgContainer: '#282828',
      colorTextTertiary: '#e49e4c',
      controlItemBgActive: 'rgba(228, 158, 76, 0.1)',
      colorFillSecondary: '#222224',
    },
    Cascader: {
      colorBgContainer: '#282828',
      colorTextTertiary: '#e49e4c',
      controlItemBgActive: 'rgba(228, 158, 76, 0.1)',
      colorFillSecondary: '#222224',
    },
    Input: {
      colorBgContainer: '#282828',
      colorTextTertiary: '#e49e4c',
    },
    InputNumber: {
      colorBgContainer: '#282828',
      colorTextTertiary: '#e49e4c',
    },
    DatePicker: {
      colorBgContainer: '#282828',
      colorLinkHover: '#e49e4c',
    },
    Tooltip: {
      fontSize: 11,
      colorBgDefault: '#282828',
      controlHeight: 'auto',
      colorTextLightSolid: '#cacaca',
    },
    Popover: {
      colorBgElevated: '#282828',
    },
    Modal: {
      colorBgElevated: '#373737',
    },
    Table: {
      colorBgContainer: '#373737',
      padding: 10,
      paddingContentVerticalLG: 10,
      colorFillAlter: 'rgba(228, 158, 76, 0.1)',
      controlItemBgActive: '#373737',
      controlItemBgActiveHover: '#373737',
    },
    Pagination: {
      colorBgContainer: '#373737',
      colorBgTextHover: 'rgba(228, 158, 76, 0.1)',
    },
    Radio: {
      colorBgContainer: '#282828',
      wireframe: 'true',
    },
  },
};

